import React, { useState } from 'react';
import { Card, Table, Input, Select, Tag, Space, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './Service.module.scss';

const { Search } = Input;
const { Option } = Select;

const ServiceList = ({ serviceList }) => {
  const [searchText, setSearchText] = useState('');
  const [filteredServices, setFilteredServices] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');

  // 서비스 목록 파싱
  const parseServiceList = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const services = [];
      const lines = data.trim().split('\n');
      
      lines.forEach(line => {
        if (line.includes('.service')) {
          const parts = line.trim().split(/\s+/);
          if (parts.length >= 3) {
            const unit = parts[0];
            const load = parts[1];
            const active = parts[2];
            const sub = parts[3] || '';
            const description = parts.slice(4).join(' ');
            
            services.push({
              unit,
              load,
              active,
              sub,
              description,
              key: unit
            });
          }
        }
      });
      
      return services;
    } catch (error) {
      console.error('Error parsing service list:', error);
      return [];
    }
  };

  const services = parseServiceList(serviceList);

  const handleSearch = (value) => {
    setSearchText(value);
    applyFilters(value, statusFilter);
  };

  const handleStatusChange = (value) => {
    setStatusFilter(value);
    applyFilters(searchText, value);
  };

  const applyFilters = (text, status) => {
    let filtered = services;
    
    if (text) {
      filtered = filtered.filter(service => 
        service.unit.toLowerCase().includes(text.toLowerCase()) ||
        service.description.toLowerCase().includes(text.toLowerCase())
      );
    }
    
    if (status !== 'all') {
      filtered = filtered.filter(service => 
        service.active.toLowerCase() === status
      );
    }
    
    setFilteredServices(filtered);
    setIsFiltered(text || status !== 'all');
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'green';
      case 'inactive':
        return 'gray';
      case 'failed':
        return 'red';
      default:
        return 'blue';
    }
  };

  return (
    <Card 
      title={
        <div>
          시스템 서비스 목록
          <Tooltip title="systemd에서 관리하는 서비스 목록입니다.">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      } 
      className={styles.serviceCard}
      extra={
        <Space>
          <Search
            placeholder="서비스 검색..."
            allowClear
            onSearch={handleSearch}
            style={{ width: 200 }}
          />
          <Select 
            defaultValue="all" 
            style={{ width: 120 }} 
            onChange={handleStatusChange}
          >
            <Option value="all">모든 상태</Option>
            <Option value="active">활성</Option>
            <Option value="inactive">비활성</Option>
            <Option value="failed">실패</Option>
          </Select>
        </Space>
      }
    >
      <Table 
        dataSource={isFiltered ? filteredServices : services}
        rowKey="key"
        pagination={{ pageSize: 10 }}
        columns={[
          { title: '서비스 유닛', dataIndex: 'unit', key: 'unit' },
          { title: '로드', dataIndex: 'load', key: 'load' },
          { 
            title: '활성 상태', 
            dataIndex: 'active', 
            key: 'active',
            render: status => <Tag color={getStatusColor(status)}>{status}</Tag>
          },
          { title: '서브 상태', dataIndex: 'sub', key: 'sub' },
          { title: '설명', dataIndex: 'description', key: 'description' }
        ]}
      />
    </Card>
  );
};

export default ServiceList;